import { createFileRoute } from '@tanstack/react-router';

import { EditExpensePage } from '@/areas/manufacturing-templates/Expenses/ExpensesCreation/EditExpensePage';
import { canEditManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/manufacturing/expenses/$expenseId/edit')({
    staticData: { access: { permissions: canEditManufacturingTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <EditExpensePage {...pathParams} />;
}
